import { useLocalization } from "@fluent/react";
import { BulletPoint } from "@lending/components/BulletPoint/BulletPoint";
import { HeroSection } from "@lending/components/HeroSection/HeroSection";
import { useHeroBreakpoints } from "@lending/hooks/useHeroBreakpoints";
import styles from "./PersonalLoanHeroSection.module.css";

function PersonalLoanHeroSection() {
  const { l10n } = useLocalization();
  const { m } = useHeroBreakpoints();

  return (
    <HeroSection
      title={l10n.getString(
        "product-selection-title",
        null,
        "Check your offer in less than 2 minutes"
      )}
      content={
        m && (
          <div className={styles.bulletPoints}>
            <BulletPoint
              text={l10n.getString(
                "product-selection-bullet-1",
                null,
                "Apply in just a few minutes"
              )}
            />
            <BulletPoint
              text={l10n.getString(
                "product-selection-bullet-2",
                null,
                "Get your decision instantly"
              )}
            />
            <BulletPoint
              text={l10n.getString("product-selection-bullet-3", null, "No application fees")}
            />
          </div>
        )
      }
    />
  );
}

export { PersonalLoanHeroSection };
